<template>
  <Row>
    <i-col :span="24" v-if="fields && isInSlug('display_name')">
      <Row type="flex" :gutter="20" align="middle" style="padding-top:15px">
        <i-col offset="2" :span="2"></i-col>
        <i-col :span="6" class="section-label m">
          Display Name </i-col>
        <i-col :span="13">
          <i-input @on-change="onChange('display_name')" v-model="profile['display_name']"></i-input>
        </i-col>
        <i-col :span="2"></i-col>
      </Row>
    </i-col>
    <i-col :span="24" v-for="(field, i) in fields" :key="i" v-if="fields && isInSlug(field.slug)">
      <FieldItem :hide-check="hideCheck" :field="field" :profile="profile" :tooltip="tooltip(field.slug)" :tooltip-position="tooltipPosition(field.slug)"></FieldItem>
    </i-col>
  </Row>
</template>

<script>
  import FieldItem from '@/views/UserProfileSettingFieldItemComponent'
  import _ from 'lodash'

  export default {
    components: {
      FieldItem
    },
    props: {
      hideCheck: {
        type: Boolean
      },
      profile: {
        type: Object
      },
      slug: {
        type: Array
      },
      tooltips: {
        type: Array
      }
    },
    methods: {
      onChange(slug) {
        BroadcastEvent.$emit('ONFIELDCHANGE', slug)
      },
      isFieldSelectionString(s) {
        return (s== 'contact_number' || s == 'about_me' || s == 'province' || s == 'country' || s == 'region') ? false : true
      },
      isInSlug(s) {
        return (this.slug.indexOf(s) > -1)
      },
      tooltip(slug) {
        let index = this.slug.indexOf(slug)
        
        if (!this.tooltips) return ''

        if(index < this.tooltips.length ) {
          return this.tooltips[index]
        } else {
          return ''
        }
      },
      tooltipPosition(slug) {
        let index = this.slug.indexOf(slug)

        if (!this.tooltips) return "left"

        if(index < 2) {
          return "left-start"
        }
        if((this.tooltip.length - index) <= 2) {
          return "left-end"
        }

        return "left"
      }
    },
    computed: {
      fields: {
        get() {
          if (this.$store.state.user.userFields.length !== undefined) {
            let fields = _.cloneDeep(this.$store.state.user.userFields);
            return fields;
          }
          return [];
        }
      }
    }
  }
</script>

<style scoped>
  .section-label {
    font-size:11px;
    line-height: 20px;
    color:#aaa;
  }
  .m {
    color: #333
  }
</style>
